
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_34338","data-name":"Group 34338","transform":"translate(-1134 -383)"}},[_c('circle',{attrs:{"id":"Ellipse_540","data-name":"Ellipse 540","cx":"7","cy":"7","r":"7","transform":"translate(1134 383)","fill":"#fc337a"}}),_c('path',{attrs:{"id":"Path_24037","data-name":"Path 24037","d":"M678.535 389.185l1.356-1.355a.692.692 0 00-.979-.979l-1.355 1.356-1.356-1.356a.692.692 0 00-.979.979l1.356 1.355-1.356 1.356a.692.692 0 00.979.979l1.356-1.356 1.355 1.356a.692.692 0 00.979-.979z","transform":"translate(463.444 .815)","fill":"#fff"}})])])
          )
        }
      }
    